module.exports = __webpack_public_path__ + "img/rule_title.838e932b.png";